import { render, staticRenderFns } from "./ReceiverList.vue?vue&type=template&id=681068b8&scoped=true&"
import script from "./ReceiverList.vue?vue&type=script&lang=js&"
export * from "./ReceiverList.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverList.vue?vue&type=style&index=0&id=681068b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681068b8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCardText,VCol,VContainer,VDataTable,VForm,VPagination,VRow,VSelect,VTextField})
